import {
  AssetOptionsContext,
  type AssetOptionsContextProps,
} from '@contexts/asset-options'
import { ContentType } from '@entries/content-types'
import ContentfulAsset from '@entries/contentful-asset'
import { withDisplayName } from '@hocs/with-display-name'
import { OpenFormButtonRefresh } from '@layouts/open-form-button-refresh'
import { Entry } from '@resolvers/entry'
import { graphql } from 'gatsby'
import React from 'react'

import ContentfulOfferRefreshLanding from './contentful-offer-refresh-landing'

const assetOptions: AssetOptionsContextProps = {
  width: '100%',
  height: 'auto',
  minSvgWidth: 'auto',
  maxSvgHeight: 'auto',
  className: 'aspect-video tablet:aspect-[4/3] rounded-[0.625rem]',
  alt: 'logo',
}

const ContentfulPageImageTitleRefreshLanding: Utils.EntryFC<
  Queries.ContentfulPageImageTitleRefreshLandingFragment
> = ({ content: { offerRef, image }, entryInspectorProps }) => (
  <div className="pb-8" {...entryInspectorProps()}>
    <div>
      <AssetOptionsContext.Provider value={assetOptions}>
        {image && (
          <Entry
            content={image}
            mapping={{
              [ContentType.ContentfulAsset]: ContentfulAsset,
            }}
          />
        )}
      </AssetOptionsContext.Provider>
    </div>
    <Entry
      content={offerRef}
      mapping={{
        [ContentType.ContentfulOffer]: ContentfulOfferRefreshLanding,
      }}
    />
    <OpenFormButtonRefresh />
  </div>
)

export const query = graphql`
  fragment ContentfulPageImageTitleRefreshLanding on Contentful3TUjMz7TxKWiQYygwIysig {
    ...ContentfulEntry
    image {
      ...ContentfulDefaultAsset
    }
    offerRef {
      ...ContentfulOfferRefreshLanding
    }
  }
`

export default withDisplayName(
  ContentfulPageImageTitleRefreshLanding,
  'ContentfulPageImageTitleRefreshLanding'
)
